export default "__VITE_ASSET__CoO2NCrT__"